import nav from './modules/nav';
import init_photos from './modules/photos';
import 'owl.carousel';

$(document).ready(function($) {
	nav();

	$('.owl-carousel').owlCarousel({
		loop:true,
		margin:10,
		nav:true,
		items: 1,
		autoplay: true,
		autoplayTimeout: 4500,
		autoplaySpeed: 800,
		autoplayHoverPause: true,
		navText: [
			'<i class="fa fa-angle-left"></i><span class="sr-only">Prev</span>',
			'<i class="fa fa-angle-right"></i><span class="sr-only">Next</span>'
		],
	}) 



	
}); 